import ac from "@/assets/svg/ac.tsx";

import electricity from "../assets/svg/electricity";
import fuel from "../assets/svg/fuel.tsx";
import gas from "../assets/svg/gas";
import heater from "../assets/svg/heater";
import water from "../assets/svg/water";
import { MeterType } from "../modules/serviceOrdering/interfaces/ServiceReport.ts";


const serviceReportMeterStyle = [
  {
    color: "#EF3826",
    type: MeterType.hotWater,
    icon: water,
  },
  {
    color: "#4883F7",
    type: MeterType.coldWater,
    icon: water,
  },
  {
    color: "#ECB900",
    type: MeterType.electricity,
    icon: electricity,
  },
  {
    color: "#1230e3",
    type: MeterType.gas,
    icon: gas,
  },
  {
    color: "#FF7D29",
    type: MeterType.heater,
    icon: heater,
  },
  {
    color: "#4883F7",
    type: MeterType.ac,
    icon: ac,
  },
  {
    color: "#FF7D29",
    type: MeterType.fuel,
    icon: fuel,
  },
];

export const getServiceReportMeterStyleByType = (type: MeterType | string) => {
  return serviceReportMeterStyle.filter(
    (entry: { type: string }) => entry.type === type,
  )[0];
};
